import React from 'react';
import { Modal, ModalProps } from 'antd';

type OptionsModalProps = ModalProps;

export const OptionsModal = ({ destroyOnClose = true, ...rest }: OptionsModalProps) => (
  <Modal centered destroyOnClose={destroyOnClose} {...rest} />
);
